export const SHOW_SECTIONS_TOOLTIP = "SHOW_SECTIONS_TOOLTIP";
